// Map campaign codes to asset folder names and images
import helppesLogo from "Assets/Images/Campaigns/Helppes/logo.png";
import helppesLanding from "Assets/Images/Campaigns/Helppes/landing.png";
import helppesThankYou from "Assets/Images/Campaigns/Helppes/thank-you.png";
import ambulanceLogo from "Assets/Images/Campaigns/Ambulance/logo.png";
import ambulanceLanding from "Assets/Images/Campaigns/Ambulance/landing.png";
import ambulanceThankYou from "Assets/Images/Campaigns/Ambulance/thank-you.png";
import hummingbirdLogo from "Assets/Images/Campaigns/Hummingbird/logo.png";
import hummingbirdLanding from "Assets/Images/Campaigns/Hummingbird/landing.png";
import hummingbirdThankYou from "Assets/Images/Campaigns/Hummingbird/thank-you.png";
import animalRescueLogo from "Assets/Images/Campaigns/AnimalRescue/logo.png";
import animalRescueLanding from "Assets/Images/Campaigns/AnimalRescue/landing.png";
import animalRescueThankYou from "Assets/Images/Campaigns/AnimalRescue/thank-you.png";
import mcdonaldLogo from "Assets/Images/Campaigns/McDonald/logo.png";
import mcdonaldLanding from "Assets/Images/Campaigns/McDonald/landing.png";
import mcdonaldThankYou from "Assets/Images/Campaigns/McDonald/thank-you.png";
import stepsLogo from "Assets/Images/Campaigns/Steps/logo.png";
import stepsLanding from "Assets/Images/Campaigns/Steps/landing.png";
import stepsThankYou from "Assets/Images/Campaigns/Steps/thank-you.png";

export type CampaignImages = {
  logo: string;
  landing: string;
  thankYou: string;
};

export const CAMPAIGN_CODE_TO_IMAGES: Record<string, CampaignImages> = {
  helppes: {
    logo: helppesLogo,
    landing: helppesLanding,
    thankYou: helppesThankYou,
  },
  sanitka: {
    logo: ambulanceLogo,
    landing: ambulanceLanding,
    thankYou: ambulanceThankYou,
  },
  kolibrici: {
    logo: hummingbirdLogo,
    landing: hummingbirdLanding,
    thankYou: hummingbirdThankYou,
  },
  "ochrana-zvirat": {
    logo: animalRescueLogo,
    landing: animalRescueLanding,
    thankYou: animalRescueThankYou,
  },
  mcdonald: {
    logo: mcdonaldLogo,
    landing: mcdonaldLanding,
    thankYou: mcdonaldThankYou,
  },
  "kroky-k-pochopeni": {
    logo: stepsLogo,
    landing: stepsLanding,
    thankYou: stepsThankYou,
  },
};

/**
 * Get campaign images by campaign code.
 * Returns null if no custom images are configured for the campaign.
 */
export const getCampaignImages = (
  campaignCode?: string | null,
): CampaignImages | null => {
  if (!campaignCode) {
    return null;
  }
  return CAMPAIGN_CODE_TO_IMAGES[campaignCode] ?? null;
};
